document.addEventListener('DOMContentLoaded', function () {
  const optionButtons = document.querySelectorAll('.product-info__option-button');
  if (!optionButtons.length) return;

  let product = null;

  // Productdata ophalen
  function loadProduct(callback) {
    if (window.product && window.product.variants) {
      product = window.product;
      callback();
      return;
    }

    const handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;

    fetch(window.location.origin + '/products/' + handle.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        product = data;
        callback();
      })
      .catch(function () {});
  }

  function getSelectedOptions() {
    const selected = {};
    document.querySelectorAll(
      '.product-info__option-button[aria-pressed="true"], .product-info__option-button.is-active'
    ).forEach(function (btn) {
      const name = btn.getAttribute('data-option-name');
      const value = btn.getAttribute('data-option-value');
      if (name && value) selected[name] = value;
    });
    return selected;
  }

  function updateUnavailable() {
    if (!product || !product.variants) return;

    const selected = getSelectedOptions();

    // Bepaal welke optie "Color/Colour" is en welke "Size"
    const colorNames = ['Color', 'Colour', 'Kleur', 'color', 'colour'];
    const sizeNames  = ['Size', 'Maat', 'size'];

    optionButtons.forEach(function (btn) {
      const optionName  = btn.getAttribute('data-option-name');
      const optionValue = btn.getAttribute('data-option-value');
      if (!optionName || !optionValue) return;

      let isAvailable = false;

      // Is dit een kleur-optie?
      if (colorNames.indexOf(optionName) !== -1) {
        // Kleur is beschikbaar als er MINSTENS 1 beschikbare variant met deze kleur is
        isAvailable = product.variants.some(function (v) {
          if (!v.available) return false;
          return [v.option1, v.option2, v.option3].indexOf(optionValue) !== -1;
        });
      }
      // Is dit een maat-optie?
      else if (sizeNames.indexOf(optionName) !== -1) {
        // Zoek de geselecteerde kleur
        let selectedColor = null;
        for (const key in selected) {
          if (colorNames.indexOf(key) !== -1) {
            selectedColor = selected[key];
            break;
          }
        }

        if (selectedColor) {
          // Maat is beschikbaar als er een variant bestaat met deze maat + de geselecteerde kleur
          isAvailable = product.variants.some(function (v) {
            if (!v.available) return false;
            const opts = [v.option1, v.option2, v.option3];
            return opts.indexOf(optionValue) !== -1 && opts.indexOf(selectedColor) !== -1;
          });
        } else {
          // Geen kleur geselecteerd → kijk of de maat ergens beschikbaar is
          isAvailable = product.variants.some(function (v) {
            if (!v.available) return false;
            return [v.option1, v.option2, v.option3].indexOf(optionValue) !== -1;
          });
        }
      }
      // Andere opties (fallback)
      else {
        isAvailable = product.variants.some(function (v) {
          if (!v.available) return false;
          const opts = [v.option1, v.option2, v.option3];
          if (opts.indexOf(optionValue) === -1) return false;

          for (const key in selected) {
            if (key === optionName) continue;
            if (opts.indexOf(selected[key]) === -1) return false;
          }
          return true;
        });
      }

      if (isAvailable) {
        btn.classList.remove('is-unavailable');
      } else {
        btn.classList.add('is-unavailable');
      }
    });
  }

  // Start
  loadProduct(function () {
    updateUnavailable();

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(updateUnavailable, 100);
      });
    });
  });
});